import Box from '@mui/material/Box/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography/Typography';
import { colors } from 'styles/colors';

export const NavigationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  margin: '0 auto 80px auto',
  maxWidth: '802px',
  height: '56px',
  backgroundColor: 'rgba(210, 232, 255, 0.2)',
  overflow: 'hidden',
  padding: '8px 24px',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyСontent: 'flex-start',
    height: 'auto',
    padding: '24px',
    overflow: 'visible',
  },
}));

export const NavigationText = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '150%',
  color: colors.mainDark,
  transition: 'color 0.3s ease-in-out',
  flex: 1,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  [theme.breakpoints.down('sm')]: {
    flex: 'none',
    whiteSpace: 'normal',
    overflow: 'visible',
  },
}));

export const NavigationIcon = styled(Box)`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
    transition: filter 0.3s ease-in-out;
    transform: rotate(180deg);
  }
`;

export const NavigationItem = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 24px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  width: 100%;
  gap: 12px;

  &:hover {
    background-color: ${colors.blue};
  }

  &:hover p {
    color: ${colors.white};
  }

  &:hover svg {
    filter: brightness(0) invert(1);
  }
`;

export const NavigationItemWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,

  '&:last-child': {
    flex: 1.5,
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    flex: 'none',
    flexDirection: 'column',
  },
}));

export const NavigationDivider = styled(Box)(({ theme }) => ({
  width: '1px',
  height: '40px',
  backgroundColor: colors.oliveBlack,
  flexShrink: 0,

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '1px',
  },
}));
